import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFileImage = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.3125 16.0039C4.0125 16.0039 3.75 15.8914 3.525 15.6664C3.3 15.4414 3.1875 15.1789 3.1875 14.8789V3.62891C3.1875 3.32891 3.3 3.06641 3.525 2.84141C3.75 2.61641 4.0125 2.50391 4.3125 2.50391H15.5625C15.8625 2.50391 16.125 2.61641 16.35 2.84141C16.575 3.06641 16.6875 3.32891 16.6875 3.62891V14.8789C16.6875 15.1789 16.575 15.4414 16.35 15.6664C16.125 15.8914 15.8625 16.0039 15.5625 16.0039H4.3125ZM4.3125 14.8789H15.5625V3.62891H4.3125V14.8789ZM5.3625 13.0602H14.5312L11.775 9.38516L9.3 12.5914L7.55625 10.2102L5.3625 13.0602Z",
		fill: "#1D1D1D"
	})
});
export default SvgFileImage;
